angular.module( 'acme.view.application.pos.create.pages.forms.addons', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.addons.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsAddons = {
        name: 'application.pos.create.pages.forms.addons',
        url: '/addons',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsAddonsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/addons/addons.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsAddons);
});
